import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/404notfound128.png'


const _withScopeId = n => (_pushScopeId("data-v-5f0e1298"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "not-found" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Page not found"),
  /*#__PURE__*/_createElementVNode("p", null, " Oops, looks like something went wrong and you ended up here. Either the page you were looking for doesn't exist or you are not authorized to view it. "),
  /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "image",
      src: _imports_0,
      alt: "Image of someone lost in the internet"
    }),
    /*#__PURE__*/_createElementVNode("p", { class: "image-caption" }, "How unfortunate.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader),
    _hoisted_1
  ], 64))
}